class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dotActive = this.querySelector('button[name="dot"].active');
    this.dotButton = this.querySelectorAll('button[name="dot"]')?.forEach((dot) => {
      dot.addEventListener('click', this.onDotClick.bind(this));
    })

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    
  }

  buttonMiddle() {
    var img = this.querySelector('a.media');
    var height = parseInt(img.clientHeight)*3/8;
    this.prevButton.style.top = height + 'px'; 
    this.nextButton.style.top = height + 'px';
  }

  initPages() {
    if (!this.slider || this.sliderItems.length === 0 || !this.sliderItems[0]) return;

    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    if (this.getAttribute('middle-arrow')) {
      this.buttonMiddle()
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: 'smooth'
    });
  }
  onDotClick(event) {
    event.preventDefault();

    let number = parseInt(event.currentTarget.getAttribute("data-position"));
    this.dotActive.classList.remove("active");
    let currentPosition = parseInt(this.dotActive.getAttribute("data-position"));
    this.dotActive = event.currentTarget;
    event.currentTarget.classList.add("active");
    let slideScrollPosition = this.slider.scrollLeft + this.sliderItems[0].clientWidth * (number - currentPosition);
    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: 'smooth'
    });
  }
}

customElements.define('slider-component', SliderComponent);
